// extracted by mini-css-extract-plugin
export default {"photoPost":"styles_photoPost__cUuna","file":"styles_file__9QHiB","preview":"styles_preview__QrjRn"};